import { CLEAR_CHAT, GET_CHAT, LOAD_MORE_CHAT } from "../actions/types";

let initialState = {
    current_page: null,
    data: [],
    first_page_url: null,
    from: null,
    last_page: null,
    last_page_url: null,
    links: [],
    next_page_url: null,
    path: null,
    per_page: null,
    prev_page_url: null,
    to: null,
    total: null,
};

const chat = (state = initialState, action) => {
    switch (action.type) {
        case GET_CHAT:
            return action.payload;
        case LOAD_MORE_CHAT:
            return {
                ...action.payload,
                data: [...state.data, ...action.payload.data],
            };
        case CLEAR_CHAT:
            return initialState;
        default:
            return state;
    }
};

export default chat;
